import { inject, Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private decodedToken: any;
  loginDisplay = false;

  private readonly msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private readonly msalService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly router = inject(Router);

  constructor() {}

  private updateDecodedTokenFromActiveAccount(): void {
    try {
      const account = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
      const claims = account?.idTokenClaims as { groups?: string[]; name?: string; upn?: string } | undefined;
      if (claims?.groups) {
        this.decodedToken = {
          ...(this.decodedToken || {}),
          groups: claims.groups,
          name: claims.name,
          upn: claims.upn,
        };
        return;
      }

      const idToken = account?.idToken;
      if (idToken) {
        this.decodedToken = jwtDecode(idToken);
      }
    } catch {
      this.decodedToken = undefined;
    }
  }

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {

      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {

        this.setLoginDisplay();
      })

  }

  getUserGroups(): string[] {
    this.updateDecodedTokenFromActiveAccount();
    return this.decodedToken?.groups || [];
  }

  isInGroup(expectedGroups: string[]): boolean {
    const userGroups = this.getUserGroups();
    return expectedGroups.some(prefix => userGroups.some(str => str.startsWith(prefix)));
  }

  setLoginDisplay(): boolean {
    try {
      this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    } catch {
      this.loginDisplay = false;
    }
    return this.loginDisplay
  }
  setLoginUserProfile(): string {
    this.updateDecodedTokenFromActiveAccount();
    return this.decodedToken?.name || "Error";
  }

  fetchLoginUserName(): string {
    this.updateDecodedTokenFromActiveAccount();
    return this.decodedToken?.upn || "Error";
  }
}
